import { createPinia } from 'pinia'
import ui from '@nuxt/ui/vue-plugin'
import { createApp } from 'vue'

import App from './App.vue'
import './assets/main.css'
import { loadSession } from './libs/auth'
import i18n from './libs/i18n'
import { createSentry } from './libs/sentry'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(i18n)
app.use(router)
app.use(ui)

createSentry(app)

// V17 — kick off the single `GET /auth/me` bootstrap before the first navigation resolves; the
// promise is parked on the app store as `sessionReady` and awaited by the router guard.
loadSession()

app.mount('#app')
